module.exports = {
          srcSet: __webpack_public_path__ + "public/images/da5ff1f9ea2f226900816c7fa758f267-628.jpg"+" 628w",
          images:[ {path: __webpack_public_path__ + "public/images/da5ff1f9ea2f226900816c7fa758f267-628.jpg",width: 628,height: 417}],
          src: __webpack_public_path__ + "public/images/da5ff1f9ea2f226900816c7fa758f267-628.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/da5ff1f9ea2f226900816c7fa758f267-628.jpg"},
          
          width: 628,
          height: 417
        }